module.exports = __webpack_public_path__ + "static/media/server-error.0b2a99d6.svg";